import { Command } from 'commands/Commands';

export class ChangeAddressDisplayName  extends Command {
  type: string = 'ChangeAddressDisplayName';
  priority: number = 100;
}
